import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneFormater' })
export class PhoneFormaterPipe implements PipeTransform {
  transform(value: any, phoneSymbol?: any, phoneBracket1?: any, phoneBracket2?: any) {
    if (phoneSymbol != '') {
      var cleaned = ('' + value).replace(/\D/g, '');
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return phoneBracket1 + match[1] + phoneBracket2 + phoneSymbol + match[2] + phoneSymbol + match[3];
      }
    } else {
      return value;
    }
  }
}
